import styled from 'styled-components';

export const BreadcrumbsWrapper = styled.div`
  margin-top: 0.5rem;
`;
